import { Message } from 'element-ui';
export default {
    install(Vue) {
        Vue.prototype.$msg = {
            success(message = '', duration = 2000) {
                return new Promise((resolve) => {
                    Message({
                        message,
                        duration,
                        type: 'success',
                        onClose: () => {
                            resolve()
                        }
                    })
                })
            },
            error(message = '', duration = 2000) {
                return new Promise((reject) => {
                    Message({
                        message,
                        duration,
                        type: 'error',
                        onClose: () => {
                            reject()
                        }
                    })
                })
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/global.js